import service from "../services/UsersService";
import User from "../entities/User";

class UsersApi {
    getLinkedUsers () {
        return new Promise((resolve, reject) => {
            service.getLinkedUsers(CurrentVirtualUserId)
                .then(res => resolve(convertJsonToUsers(res.data)))
                .catch(err => reject(err));
        });
    }

    deleteUserLink (userId) {
        return new Promise((resolve, reject) => {
            service.unassign(userId)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    linkUserToSite (site, login, password) {
        var request = {
            Site: site,
            Login: login,
            Password: password
        };
        return new Promise((resolve, reject) => {
            service.assign(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    getLinkedUsersByProduct(virtualProductId) {
        return new Promise((resolve, reject) => {
            service.getLinkedUsersByProduct(CurrentVirtualUserId, virtualProductId)
                .then(res => resolve(convertJsonToUsers(res.data)))
                .catch(err => reject(err));
        });
    }

    getUsersByOrgId (orgId, excludeInactive, filterByProductId, filterByTeamId) {
        const filter = {
            ExcludeInactive: excludeInactive,
            FilterByProductId: filterByProductId,
            FilterByTeamId: filterByTeamId
        };
        return new Promise((resolve, reject) => {
            service.getUsersByOrgId(orgId, filter)
                .then(res => resolve(convertJsonToUsers(res.data)))
                .catch(err => reject(err));
        });
    }
}

export default new UsersApi();

const convertJsonToUsers = (json) => {
    if (json)
        return json.map(item => new User(item)).sort(sortByName);
};

const sortByName = (a, b) => {
    if (a.userName > b.userName) {
        return 1;
    }
    if (a.userName < b.userName) {
        return -1;
    }
    return 0;
};
